import { SAVED_COURSES_TRANSLATION_KEY } from "../constants.js";
const translation = {
    [SAVED_COURSES_TRANSLATION_KEY]: {
        SC_BOOKMARK_REMOVED_COURSE: 'Curso eliminado de "Mis guardados"',
        SC_BOOKMARK_ADDED_COURSE: 'Curso guardado en "Mis guardados"',
        SC_ERROR_SAVE_COURSE: "Error al guardar el curso, por favor inténtelo más tarde",
        SC_ERROR_DELETE_COURSE: "Error al eliminar el curso, por favor inténtelo más tarde"
    }
};
const es = translation;
export default es;
